function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeTypeRecurring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3e5fc",
      fillOpacity: 0.45959595
    },
    d: "M34.398 43H13.602C8.898 43 5 39.102 5 34.398V13.602C5 8.898 8.898 5 13.602 5H34.3c4.8 0 8.597 3.898 8.597 8.602V34.3C43 39.1 39.102 43 34.398 43Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#12394b",
      fillOpacity: 0.60101008
    },
    d: "M43 16h-2v6h2Zm0 10h-2v6h2ZM7 16H5v6h2Zm0 10H5v6h2Zm9-19h6V5h-6Zm10 0h6V5h-6ZM16 43h6v-2h-6Zm11 0h6v-2h-6Zm-15-.2c-3.5-.698-6.2-3.402-6.8-6.8h2.1c.598 2.398 2.4 4.2 4.802 4.8v2Zm0-37.6v2.1c-2.398.5-4.2 2.302-4.8 4.7h-2A8.29 8.29 0 0 1 12 5.2Zm24 2v-2c3.5.698 6.2 3.402 6.8 6.8h-2.1c-.5-2.398-2.302-4.2-4.7-4.8ZM40.8 36h2.098c-.699 3.5-3.398 6.2-6.796 6.8v-2.1c2.296-.5 4.097-2.302 4.699-4.7Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeTypeRecurring);
export default __webpack_public_path__ + "static/media/noticeTypeRecurring.aab4e74fdc5820f3cb5f7bdbd1725eb1.svg";
export { ForwardRef as ReactComponent };